export default {
  applies_to_articles: 'Gælder for følgende varer',
};
